<section class="content">
    <!-- Default box -->
    <div class="container-fluid">
        <div class="card">
          <div class="card-header  bg-primary text-white">
            <i class="fa fa-plus-circle" aria-hidden="true" style="float: left; font-size: 1.5em !important; padding-right: 10px;"></i>
            &nbsp;<h3 class="card-title">New ICD Application</h3>

            <!--<div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>-->
          </div>
            <div class="card-body">

              <!-- Pre-Submit Review Modal -->
              <app-pre-submit-review
                [visible]="showReview"
                [issues]="reviewIssues"
                [loading]="reviewLoading"
                (recheck)="onReviewRecheck()"
                (submitAnyway)="onReviewSubmit()"
                (dismiss)="onReviewDismiss()"
                (autoFix)="onReviewAutoFix($event)"
                (navigateToField)="onReviewNavigate($event)">
              </app-pre-submit-review>

              <div class="row">

                <div class="row">
                  <div class="col-sm-8">
                    <div class="form-check mb-3">
                      Will the potential new ICD be participating in any Due Diligence Campaigns? <code>*</code>
                      <button type="button"
                              class="btn btn-sm btn-info ml-2"
                              title="View all due diligence campaigns"
                              (click)="showAllDueDiligenceCampaigns()">
                        <i class="fa fa-info-circle"></i>
                      </button>
                      <br />

                      <input type="radio" name="iSDueDel" value="Yes" id="iSDueDelYesRadio" [checked]="iSDueDelValue === 'Yes'" (change)="oniSDueDel('Yes')" class="form-check-input" />
                      <label for="iSDueDelYesRadio" class="form-check-label">Yes</label><br />
                      <input type="radio" name="iSDueDel" value="No" id="iSDueDelNoRadio" [checked]="iSDueDelValue === 'No'" (change)="oniSDueDel('No')" class="form-check-input" />
                      <label for="iSDueDelNoRadio" class="form-check-label">No </label>

                    </div>

                  </div>
                  <div class="col-sm-4" >
                    <div class="form-check mb-3">
                      
                      <button type="button"
                              *ngIf="IsDueDelVis && !Campaigns_isSelectedItemsinvalid && iSDueDelYes && selected_AccPo && selected_AccPoRep && campsdatafilter"

                              (click)="proceed()" class="btn btn-success float-right">
                        Proceed
                      </button>


                    </div>

                  </div>

                  <div class="col-sm-4" *ngIf="iSDueDelYes && IsDueDelVis">
                    <div class="form-group">
                      <label class="col-form-label col-md-12" for="login-campaignName">Promoting Owner / Existing Owner <code>*</code></label>
                      <div class="col-md-12">
                        <input type="text" class="form-control" [(ngModel)]="searchText" placeholder="Enter Promoting Owner Name" (input)="filterOwners()">

                      </div>
                    </div>
                    <span *ngIf="selected_camp" style="color:red;">Select Promoting Owner from below table</span>

                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Select</th>

                          <th>Owner Name</th>
                          <th>Owner Company</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let owner of filteredOwners">

                          <td><input type="radio" [value]="owner.id" (change)="onCheckbox_AccPO(owner)" [checked]="selected_AccPo === owner.ownerName"></td>

                          <td>{{ owner.ownerName }}</td>
                          <td>{{ owner.owner_Name_Company }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-sm-4" *ngIf="iSDueDelYes && selected_AccPo && IsDueDelVis">


                    <label class="col-form-label  col-md-12" for="login-Owner_Middle_Name"></label>
                    <div class="form-group col-md-12">
                      <div class="custom-control custom-switch custom-switch-on-success">
                        <input type="checkbox" class="custom-control-input" id="isPOICDOCheckbox" [checked]="isPOICDNO" (change)="togglePOICDO($event)" />
                        <label class="custom-control-label" for="isPOICDOCheckbox">Existing Owner Opening a New Corp</label>
                      </div>
                    </div>

                    <span *ngIf="iSDueDelYes && !isPOICDNO" style="color:red;">Select New ICD Owner</span>
                    <div class="form-group" *ngIf="!isPOICDNO">
                      <label class="col-form-label  col-md-12" for="login-campaignName">New ICD Owner <code>*</code></label>
                      <div class="col-md-12">

                        <ng-select [searchable]="true" [(ngModel)]="selected_AccPoRep"
                                   [ngModelOptions]="{ standalone: true }" (change)="onCheckbox_AccPORep($event)">
                          <ng-option *ngFor="let o of getFilteredAccPoRep()"
                                     [value]="o.icD_Rep_Name">
                            {{ o.icD_Rep_Name }}
                          </ng-option>
                        </ng-select>


                      </div>
                    </div>
                  </div>
                  <div *ngIf="iSDueDelYes && selected_AccPo && selected_AccPoRep && IsDueDelVis" class="col-md-4">
                    <span style="color:red;" *ngIf="campsdatafilter">Select the Campaign</span><br />
                    <span style="color:red;" *ngIf="!campsdatafilter">No Campaign's available for selected Rep</span>
                    <div class="col-md-12" *ngFor="let item of campsdatafilter">
                      <div class="form-group">
                        <div class="custom-control custom-switch  custom-switch-on-success">
                          <input type="checkbox" class="custom-control-input" [id]="item.id" [checked]="Campaigns_selectedItems.includes(item.campaignName)"
                                 [name]="'campaignSelection'" [value]="item.campaignName" (change)="onCheckboxChange_Campaigns($event, item.campaignName)">
                          <label class="custom-control-label" [for]="item.id">{{ item.campaignName + " ("+ item.name + ")" }}</label>
                        </div>
                      </div>

                    </div>
                  </div>



                </div>

              </div>
              <div class="row" [hidden]="!IsFormVis">
                <form *ngIf="formResetToggle" class="login" name="loginForm"
                      [formGroup]="icdForm" (ngSubmit)="onSubmit()" novalidate>
                  <!-- general form elements disabled -->
                  <div class="card card-secondary">
                    <div class="card-header">
                      <h3 class="card-title">ICD Information</h3>
                      <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                          <i class="fas fa-minus"></i>
                        </button>
                      </div>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">

                      <div class="row">
                        <div class="col-sm-4" [appFieldIssue]="'US_or_CA'">
                          <label class="col-form-label col-md-12" for="US_or_CA_US">Country <code>*</code></label>
                          <div class="col-md-12">
                            <div class="form-check">
                              <input type="radio" formControlName="US_or_CA" value="US" id="US_or_CA_US" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />
                              <label for="US_or_CA_US" class="form-check-label">US</label>
                            </div>
                            <div class="form-check">
                              <input type="radio" formControlName="US_or_CA" value="Canada" id="US_or_CA_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />
                              <label for="US_or_CA_CA" class="form-check-label">Canada</label>
                            </div>
                            <div *ngIf="submitted && f.US_or_CA.errors" class="invalid-feedback d-block">Country is required</div>
                          </div>
                        </div>

                      </div>
                      <div class="row">
                        <div class="col-sm-4" [appFieldIssue]="'Owner_First_Name'">


                          <label class="col-form-label  col-md-12" for="login-Owner_First_Name">Owner's Legal First Name <code>*</code></label>
                          <input type="text" formControlName="Owner_First_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_First_Name"
                                 [ngClass]="{'is-valid':  f.Owner_First_Name.valid, 'is-invalid' :submitted && !f.Owner_First_Name.valid}" placeholder="Enter Owner Legal First Name"
                                 appAiHint="Owner First Name" [aiHintForm]="icdForm" />
                          <div class="text-right small mt-1"
                               [ngClass]="{'text-danger': f.Owner_First_Name.errors?.maxlength,'text-muted': !f.Owner_First_Name.errors?.maxlength}">

                            {{ icdForm.get('Owner_First_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_First_Name }}

                          </div>
                          <div *ngIf="submitted && f.Owner_First_Name.errors" class="invalid-feedback">
                            <div *ngIf="f.Owner_First_Name.errors.required">First Name is required</div>
                            <div *ngIf="f.Owner_First_Name.errors.maxlength">
                              Maximum {{ fieldMaxLengths.Owner_First_Name }} characters allowed
                            </div>
                          </div>


                        </div>
                        <div class="col-sm-4" [appFieldIssue]="'Owner_Middle_Name'">


                          <label class="col-form-label  col-md-12" for="login-Owner_Middle_Name">Owner's Legal Middle Name <code>*</code></label>
                          <div class="form-group col-md-12">
                            <div class="custom-control custom-switch custom-switch-on-success">
                              <input type="checkbox" class="custom-control-input" id="noMiddleNameCheckbox" [checked]="noMiddleName" (change)="toggleMiddleName($event)" />
                              <label class="custom-control-label" for="noMiddleNameCheckbox">ICD doesn't have a middle name</label>
                            </div>
                          </div>
                          <input type="text" *ngIf="!noMiddleName" formControlName="Owner_Middle_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Middle_Name"
                                 [ngClass]="{'is-valid':  f.Owner_Middle_Name.valid, 'is-invalid' :submitted && !f.Owner_Middle_Name.valid}" placeholder="Enter Owner Legal Middle Name"
                                 appAiHint="Owner Middle Name" [aiHintForm]="icdForm" />
                          <div class="text-right small mt-1" *ngIf="!noMiddleName"
                               [ngClass]="{'text-danger': f.Owner_Middle_Name.errors?.maxlength,'text-muted': !f.Owner_Middle_Name.errors?.maxlength}">

                            {{ icdForm.get('Owner_Middle_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Middle_Name }}

                          </div>
                          <div *ngIf="submitted && !noMiddleName && f.Owner_Middle_Name.errors" class="invalid-feedback d-block">
                            <div *ngIf="f.Owner_Middle_Name.errors.required">
                              Middle Name is required
                            </div>
                            <div *ngIf="f.Owner_Middle_Name.errors.maxlength">
                              Maximum {{ fieldMaxLengths.Owner_Middle_Name }} characters allowed
                            </div>
                          </div>


                        </div>
                        <div class="col-sm-4">
                          <div class="form-group" [appFieldIssue]="'Owner_Last_Name'">


                            <label class="col-form-label  col-md-12" for="login-Owner_Last_Name">Owner's Legal Last Name <code>*</code></label>
                            <input type="text" formControlName="Owner_Last_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Last_Name"
                                   [ngClass]="{'is-valid': f.Owner_Last_Name.valid, 'is-invalid' : submitted && !f.Owner_Last_Name.valid}" placeholder="Enter Owner Legal Last Name"
                                   appAiHint="Owner Last Name" [aiHintForm]="icdForm" />
                            <div class="text-right small mt-1"
                                 [ngClass]="{'text-danger': f.Owner_Last_Name.errors?.maxlength,'text-muted': !f.Owner_Last_Name.errors?.maxlength}">

                              {{ icdForm.get('Owner_Last_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Last_Name }}

                            </div>
                            <div *ngIf="submitted && f.Owner_Last_Name.errors" class="invalid-feedback">
                              <div *ngIf="f.Owner_Last_Name.errors.required">Last Name is required</div>
                              <div *ngIf="f.Owner_Last_Name.errors.maxlength">
                                Maximum {{ fieldMaxLengths.Owner_Last_Name }} characters allowed
                              </div>
                            </div>


                          </div>
                        </div>
                        <div class="row">

                          <div class="col-sm-12 mb-3">
                            <label class="col-form-label col-md-12" for="Is_Preferred_Differ_Yes">Does Owner have a different preferred name? <code>*</code></label>
                            <div class="col-md-12">
                              <div class="form-check">
                                <input type="radio" value="Yes" formControlName="Is_Preferred_Differ" id="Is_Preferred_Differ_Yes" (change)="onIsPreferChange('Yes')" class="form-check-input" />
                                <label for="Is_Preferred_Differ_Yes" class="form-check-label">Yes</label>
                              </div>
                              <div class="form-check">
                                <input type="radio" value="No" formControlName="Is_Preferred_Differ" id="Is_Preferred_Differ_No" (change)="onIsPreferChange('No')" class="form-check-input" />
                                <label for="Is_Preferred_Differ_No" class="form-check-label">No</label>
                              </div>
                              <div *ngIf="submitted && f.Is_Preferred_Differ.errors" class="invalid-feedback d-block">Preferred Name selection is required</div>
                            </div>
                          </div>

                          <div class="col-sm-4" *ngIf="IsPref_Differ">
                            <div class="form-group">

                              <label class="col-form-label  col-md-12" for="login-Owner_Preferred_First_Name">Preferred First Name <code>*</code></label>
                              <input type="text" formControlName="Owner_Preferred_First_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Preferred_First_Name"
                                     placeholder="Enter Preferred First Name"
                                     appAiHint="Owner Preferred First Name" [aiHintForm]="icdForm" />
                              <div class="text-right small mt-1"
                                   [ngClass]="{'text-danger': f.Owner_Preferred_First_Name.errors?.maxlength,'text-muted': !f.Owner_Preferred_First_Name.errors?.maxlength}">

                                {{ icdForm.get('Owner_Preferred_First_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Preferred_First_Name }}

                              </div>
                              <div *ngIf="submitted && f.Owner_Preferred_First_Name.errors" class="invalid-feedback">
                                <div *ngIf="f.Owner_Preferred_First_Name.errors.required">Preferred First Name is required</div>
                                <div *ngIf="f.Owner_Preferred_First_Name.errors.maxlength">
                                  Maximum {{ fieldMaxLengths.Owner_Preferred_First_Name }} characters allowed
                                </div>

                              </div>
                            </div>
                          </div>
                          <div class="col-sm-4" *ngIf="IsPref_Differ">
                            <div class="form-group">

                              <label class="col-form-label  col-md-12" for="login-Owner_Preferred_Last_Name">Preferred Last Name <code>*</code></label>
                              <input type="text" formControlName="Owner_Preferred_Last_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Preferred_Last_Name"
                                     placeholder="Enter Preferred Last Name"
                                     appAiHint="Owner Preferred Last Name" [aiHintForm]="icdForm" />
                              <div class="text-right small mt-1"
                                   [ngClass]="{'text-danger': f.Owner_Preferred_Last_Name.errors?.maxlength,'text-muted': !f.Owner_Preferred_Last_Name.errors?.maxlength}">

                                {{ icdForm.get('Owner_Preferred_Last_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Preferred_Last_Name }}

                              </div>
                              <div *ngIf="submitted && f.Owner_Preferred_Last_Name.errors" class="invalid-feedback">
                                <div *ngIf="f.Owner_Preferred_Last_Name.errors.required">Preferred Last Name is required</div>
                                <div *ngIf="f.Owner_Preferred_Last_Name.errors.maxlength">
                                  Maximum {{ fieldMaxLengths.Owner_Preferred_Last_Name }} characters allowed
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Feature 10 — Secondary owner -->
                          <div class="col-sm-12 mb-3">
                            <label class="col-form-label col-md-12" for="Has_Secondary_Owner_Yes">Does this corporation have a secondary owner? <code>*</code></label>
                            <div class="col-md-12">
                              <div class="form-check">
                                <input type="radio" value="Yes" formControlName="Has_Secondary_Owner" id="Has_Secondary_Owner_Yes" (change)="onHasSecondaryOwnerChange('Yes')" class="form-check-input" />
                                <label for="Has_Secondary_Owner_Yes" class="form-check-label">Yes</label>
                              </div>
                              <div class="form-check">
                                <input type="radio" value="No" formControlName="Has_Secondary_Owner" id="Has_Secondary_Owner_No" (change)="onHasSecondaryOwnerChange('No')" class="form-check-input" />
                                <label for="Has_Secondary_Owner_No" class="form-check-label">No</label>
                              </div>
                              <div *ngIf="submitted && f.Has_Secondary_Owner.errors" class="invalid-feedback d-block">Please select whether there is a secondary owner</div>
                            </div>
                          </div>

                          <div class="col-sm-4" *ngIf="hasSecondaryOwner">
                            <div class="form-group">
                              <label class="col-form-label col-md-12" for="login-Secondary_Owner_First_Name">Secondary ICD First Name <code>*</code></label>
                              <input type="text" formControlName="Secondary_Owner_First_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Secondary_Owner_First_Name"
                                     [ngClass]="{'is-valid': f.Secondary_Owner_First_Name.valid, 'is-invalid': submitted && !f.Secondary_Owner_First_Name.valid}" placeholder="Enter Secondary ICD First Name"
                                     appAiHint="Secondary Owner First Name" [aiHintForm]="icdForm" />
                              <div class="text-right small mt-1"
                                   [ngClass]="{'text-danger': f.Secondary_Owner_First_Name.errors?.maxlength,'text-muted': !f.Secondary_Owner_First_Name.errors?.maxlength}">
                                {{ icdForm.get('Secondary_Owner_First_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Secondary_Owner_First_Name }}
                              </div>
                              <div *ngIf="submitted && f.Secondary_Owner_First_Name.errors" class="invalid-feedback">
                                <div *ngIf="f.Secondary_Owner_First_Name.errors.required">First Name is required</div>
                                <div *ngIf="f.Secondary_Owner_First_Name.errors.maxlength">Maximum {{ fieldMaxLengths.Secondary_Owner_First_Name }} characters allowed</div>
                              </div>
                            </div>
                          </div>

                          <div class="col-sm-4" *ngIf="hasSecondaryOwner">
                            <div class="form-group">
                              <label class="col-form-label col-md-12" for="login-Secondary_Owner_Middle_Name">Secondary ICD Middle Name</label>
                              <div class="form-group col-md-12">
                                <div class="custom-control custom-switch custom-switch-on-success">
                                  <input type="checkbox" class="custom-control-input" id="noSecondaryMiddleNameCheckbox" [checked]="noSecondaryMiddleName" (change)="toggleSecondaryMiddleName($event)" />
                                  <label class="custom-control-label" for="noSecondaryMiddleNameCheckbox">ICD doesn't have a middle name</label>
                                </div>
                              </div>
                              <input type="text" *ngIf="!noSecondaryMiddleName" formControlName="Secondary_Owner_Middle_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Secondary_Owner_Middle_Name"
                                     [ngClass]="{'is-valid': f.Secondary_Owner_Middle_Name.valid, 'is-invalid': submitted && !f.Secondary_Owner_Middle_Name.valid}" placeholder="Enter Secondary ICD Middle Name"
                                     appAiHint="Secondary Owner Middle Name" [aiHintForm]="icdForm" />
                              <div class="text-right small mt-1" *ngIf="!noSecondaryMiddleName"
                                   [ngClass]="{'text-danger': f.Secondary_Owner_Middle_Name.errors?.maxlength,'text-muted': !f.Secondary_Owner_Middle_Name.errors?.maxlength}">
                                {{ icdForm.get('Secondary_Owner_Middle_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Secondary_Owner_Middle_Name }}
                              </div>
                              <div *ngIf="submitted && !noSecondaryMiddleName && f.Secondary_Owner_Middle_Name.errors" class="invalid-feedback d-block">
                                <div *ngIf="f.Secondary_Owner_Middle_Name.errors.required">Middle Name is required</div>
                                <div *ngIf="f.Secondary_Owner_Middle_Name.errors.maxlength">Maximum {{ fieldMaxLengths.Secondary_Owner_Middle_Name }} characters allowed</div>
                              </div>
                            </div>
                          </div>

                          <div class="col-sm-4" *ngIf="hasSecondaryOwner">
                            <div class="form-group">
                              <label class="col-form-label col-md-12" for="login-Secondary_Owner_Last_Name">Secondary ICD Last Name <code>*</code></label>
                              <input type="text" formControlName="Secondary_Owner_Last_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Secondary_Owner_Last_Name"
                                     [ngClass]="{'is-valid': f.Secondary_Owner_Last_Name.valid, 'is-invalid': submitted && !f.Secondary_Owner_Last_Name.valid}" placeholder="Enter Secondary ICD Last Name"
                                     appAiHint="Secondary Owner Last Name" [aiHintForm]="icdForm" />
                              <div class="text-right small mt-1"
                                   [ngClass]="{'text-danger': f.Secondary_Owner_Last_Name.errors?.maxlength,'text-muted': !f.Secondary_Owner_Last_Name.errors?.maxlength}">
                                {{ icdForm.get('Secondary_Owner_Last_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Secondary_Owner_Last_Name }}
                              </div>
                              <div *ngIf="submitted && f.Secondary_Owner_Last_Name.errors" class="invalid-feedback">
                                <div *ngIf="f.Secondary_Owner_Last_Name.errors.required">Last Name is required</div>
                                <div *ngIf="f.Secondary_Owner_Last_Name.errors.maxlength">Maximum {{ fieldMaxLengths.Secondary_Owner_Last_Name }} characters allowed</div>
                              </div>
                            </div>
                          </div>





                        </div>


                      </div>
                      <div class="row">
                        <div class="col-sm-4">
                          <div class="form-group" [appFieldIssue]="'Full_Legal_Company_Name'">

                            <label class="col-form-label  col-md-12" for="login-Full_Legal_Company_Name">Full Legal Company Name <code>*</code></label>
                            <input type="text" formControlName="Full_Legal_Company_Name" class="form-control" [attr.maxlength]="fieldMaxLengths.Full_Legal_Company_Name"
                                   [ngClass]="{'is-valid': f.Full_Legal_Company_Name.valid, 'is-invalid' : submitted && !f.Full_Legal_Company_Name.valid}" placeholder="Enter Full Legal Company Name"
                                   appAiHint="Full Legal Company Name" [aiHintForm]="icdForm" />
                            <div class="text-right small mt-1"
                                 [ngClass]="{'text-danger': f.Full_Legal_Company_Name.errors?.maxlength,'text-muted': !f.Full_Legal_Company_Name.errors?.maxlength}">

                              {{ icdForm.get('Full_Legal_Company_Name')?.value?.length || 0 }}/{{ fieldMaxLengths.Full_Legal_Company_Name }}

                            </div>
                            <div *ngIf="submitted && f.Full_Legal_Company_Name.errors" class="invalid-feedback">
                              <div *ngIf="f.Full_Legal_Company_Name.errors.required">Full Legal Company Name  is required</div>
                              <div *ngIf="f.Full_Legal_Company_Name.errors.maxlength">
                                Maximum {{ fieldMaxLengths.Full_Legal_Company_Name }} characters allowed
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="col-sm-4">

                          <div class="form-group" [appFieldIssue]="'Tax_ID'">

                            <label class="col-form-label  col-md-12" for="login-Tax_ID">F.E.I.N. # (Tax ID)/Business # <code>*</code></label>
                            <input type="text" formControlName="Tax_ID" class="form-control" [attr.maxlength]="fieldMaxLengths.Tax_ID"
                                   appFeinMask [feinCountry]="selectedCountry"
                                   [ngClass]="{'is-valid': f.Tax_ID.valid, 'is-invalid' : (submitted && !f.Tax_ID.valid) || f.Tax_ID.errors?.taxIdExists}" placeholder="Enter  F.E.I.N. # (Tax ID)/Business"
                                   appAiHint="F.E.I.N. Tax ID (EIN)" [aiHintForm]="icdForm" />
                            <div *ngIf="f.Tax_ID.pending" class="text-muted small mt-1">
                              <i class="fa fa-spinner fa-spin"></i> Checking Tax ID...
                            </div>
                            <div class="text-right small mt-1"
                                 [ngClass]="{'text-danger': f.Tax_ID.errors?.maxlength,'text-muted': !f.Tax_ID.errors?.maxlength}">

                              {{ icdForm.get('Tax_ID')?.value?.length || 0 }}/{{ fieldMaxLengths.Tax_ID }}

                            </div>
                            <div *ngIf="submitted && f.Tax_ID.errors" class="invalid-feedback">
                              <div *ngIf="f.Tax_ID.errors.required">F.E.I.N. # (Tax ID)/Business #  is required</div>
                              <div *ngIf="f.Tax_ID.errors.maxlength">
                                Maximum {{ fieldMaxLengths.Tax_ID }} characters allowed
                              </div>
                            </div>
                            <div *ngIf="f.Tax_ID.errors?.taxIdExists" class="invalid-feedback d-block">
                              A distributor with this Tax ID already exists in Salesforce. Please contact support if this is an error.
                            </div>


                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="form-group" [appFieldIssue]="'Tax_ID_C'">

                            <label class="col-form-label  col-md-12" for="login-Tax_ID_C">Confirm F.E.I.N. # (Tax ID)/Business # <code>*</code></label>
                            <input type="text" formControlName="Tax_ID_C" class="form-control" [attr.maxlength]="fieldMaxLengths.Tax_ID_C"
                                   appFeinMask [feinCountry]="selectedCountry"
                                   [ngClass]="{'is-valid': f.Tax_ID_C.valid, 'is-invalid' : submitted && !f.Tax_ID_C.valid}" placeholder="Enter Confirm F.E.I.N. # (Tax ID)/Business"
                                   appAiHint="Confirm Tax ID" [aiHintForm]="icdForm" />
                            <div class="text-right small mt-1"
                                 [ngClass]="{'text-danger': f.Tax_ID_C.errors?.maxlength,'text-muted': !f.Tax_ID_C.errors?.maxlength}">

                              {{ icdForm.get('Tax_ID_C')?.value?.length || 0 }}/{{ fieldMaxLengths.Tax_ID_C }}

                            </div>
                            <div *ngIf="submitted && f.Tax_ID_C.errors" class="invalid-feedback">
                              <div *ngIf="f.Tax_ID_C.errors.required">Confirm F.E.I.N. # (Tax ID)/Business #  is required</div>
                              <div *ngIf="f.Tax_ID_C.errors.mustMatch">F.E.I.N. # (Tax ID)/Business #  must match</div>
                              <div *ngIf="f.Tax_ID_C.errors.maxlength">
                                Maximum {{ fieldMaxLengths.Tax_ID_C }} characters allowed
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-4">
                          <div class="form-group" [appFieldIssue]="'Owner_Email'">

                            <label class="col-form-label  col-md-12" for="login-Owner_Email">Owner's Email <code>*</code></label>
                            <input type="text" formControlName="Owner_Email" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Email"
                                   [ngClass]="{'is-valid': f.Owner_Email.valid, 'is-invalid' : submitted && !f.Owner_Email.valid}" placeholder="Enter Owner's Email"
                                   appAiHint="Owner Email" [aiHintForm]="icdForm" />
                            <div class="text-right small mt-1"
                                 [ngClass]="{'text-danger': f.Owner_Email.errors?.maxlength,'text-muted': !f.Owner_Email.errors?.maxlength}">

                              {{ icdForm.get('Owner_Email')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Email }}

                            </div>
                            <div *ngIf="submitted && f.Owner_Email.errors" class="invalid-feedback">
                              <div *ngIf="f.Owner_Email.errors.required">Owner's Email  is required</div>
                              <div *ngIf="f.Owner_Email.errors.email">Email must be a valid email address</div>
                              <div *ngIf="f.Owner_Email.errors.maxlength">
                                Maximum {{ fieldMaxLengths.Owner_Email }} characters allowed
                              </div>
                            </div>


                          </div>
                        </div>
                        <div class="col-sm-4">

                          <div class="form-group" [appFieldIssue]="'Date_of_Incorporation'">

                            <label class="col-form-label  col-md-12" for="login-Date_of_Incorporation">Date of Incorporation <code>*</code></label>
                            <div class="input-group date" id="reservationdate" data-target-input="nearest">
                              <input type="text" formControlName="Date_of_Incorporation" data-target="#reservationdate" autocomplete="off"
                                     id="Date_of_Incorporation" placeholder="Select Date of Incorporation"
                                     class="form-control" [ngClass]="{'is-valid': submitted && f.Date_of_Incorporation.valid, 'is-invalid' : submitted && !f.Date_of_Incorporation.valid}"
                                     appAiHint="Date of Incorporation" [aiHintForm]="icdForm" />
                              <div class="input-group-append" style="pointer-events: none;" data-target="#reservationdate" data-toggle="datetimepicker">
                                <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                              </div>
                              <div *ngIf="submitted && f.Date_of_Incorporation.errors" class="invalid-feedback">
                                <div *ngIf="f.Date_of_Incorporation.errors.required">Date of Incorporation is required</div>
                                <div *ngIf="f.Date_of_Incorporation.errors.pattern && !f.Date_of_Incorporation.errors.required">Date of Incorporation must be a valid date in the format MM-DD-YYYY</div>
                              </div>


                            </div>


                          </div>
                        </div>

                        <div class="col-sm-4" *ngIf="selectedCountry == 'US'">

                          <div class="form-group" [appFieldIssue]="'State_of_Incorporation'">

                            <div class="col-md-12">
                              <label class="form-label">State of Incorporation <code>*</code></label>

                              <ng-select [searchable]="true" formControlName="State_of_Incorporation" [ngClass]="{ 'is-invalid': submitted && f.State_of_Incorporation.errors }">
                                <ng-option *ngFor="let o of ddlUSStates"
                                           [value]="o.value">
                                  {{ o.name }}
                                </ng-option>
                              </ng-select>
                              <div *ngIf="submitted && f.State_of_Incorporation.errors" class="invalid-feedback">
                                <div *ngIf="f.State_of_Incorporation.errors.required">State of Incorporation is required</div>
                              </div>


                            </div>




                          </div>
                        </div>


                        <div class="col-sm-4" *ngIf="selectedCountry == 'Canada'">

                          <div class="form-group" [appFieldIssue]="'Provinence_of_Incorporation'">

                            <div class="col-md-12">
                              <label class="form-label">Province of Incorporation <code>*</code></label>

                              <ng-select [searchable]="true" formControlName="Provinence_of_Incorporation" [ngClass]="{ 'is-invalid': submitted && f.Provinence_of_Incorporation.errors }">
                                <ng-option *ngFor="let o of ddlCAProvinence"
                                           [value]="o.value">
                                  {{ o.name }}
                                </ng-option>
                              </ng-select>
                              <div *ngIf="submitted && f.Provinence_of_Incorporation.errors" class="invalid-feedback">
                                <div *ngIf="f.Provinence_of_Incorporation.errors.required">Province Incorporation is required</div>
                              </div>


                            </div>




                          </div>
                        </div>

                        <div class="col-sm-4" *ngIf="selectedCountry == 'US'">

                          <div class="form-group" [appFieldIssue]="'Promoting_Owner_US'">
                            <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner <code>*</code></label>
                            <div class="col-md-12">

                              <ng-select [searchable]="true" formControlName="Promoting_Owner_US" (change)="onCheckboxPo_US($event)">
                                <ng-option *ngFor="let o of PO_namesData_US"
                                           [value]="o.ownerName">
                                  {{ o.ownerNameCompany }}
                                </ng-option>
                              </ng-select>

                              <div *ngIf="submitted && f.Promoting_Owner_US.errors" class="invalid-feedback">
                                <div *ngIf="f.Promoting_Owner_US.errors.required">Promoting Owner is required</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4"  *ngIf="selectedCountry == 'Canada'">

                          <div class="form-group" [appFieldIssue]="'Promoting_Owner_CA'">
                            <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner <code>*</code></label>
                            <div class="col-md-12">

                              <ng-select [searchable]="true" formControlName="Promoting_Owner_CA" (change)="onCheckboxPo_CA($event)">
                                <ng-option *ngFor="let o of PO_namesData_CA"
                                           [value]="o.ownerName">
                                  {{ o.ownerNameCompany }}
                                </ng-option>
                              </ng-select>

                              <div *ngIf="submitted && f.Promoting_Owner_CA.errors" class="invalid-feedback">
                                <div *ngIf="f.Promoting_Owner_CA.errors.required">Promoting Owner is required</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">

                          <div class="form-group">
                            <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner's Company <code>*</code></label>
                            <input type="text" formControlName="Promoting_Owner_Company" class="form-control"
                                 placeholder="Enter Promoting Owner Company"
                                 appAiHint="Promoting Owner Company" [aiHintForm]="icdForm" />
                          </div>


                        </div>

                      </div>
                    </div>

                    </div>
                      <!-- /.card-body -->
                     
                  <!-- /.card -->
                  <!-- general form elements disabled -->
                  <div class="card card-secondary">
                    <div class="card-header">
                      <h3 class="card-title">HUB Information</h3>
                      <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                          <i class="fas fa-minus"></i>
                        </button>
                      </div>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-4">

                          <div class="form-group">
                            <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Name">Hub Name <code>*</code></label>
                            <div class="col-md-12">
                              <input   type="text" id="login-HUB_Manager_Contact_Name" name="HUB_Manager_Contact_Name"
                                     placeholder="Enter Manager Contact Name" autocomplete="HUB_Manager_Contact_Name"
                                     class="form-control"  formControlName="HUB_Manager_Contact_Name"
                                     appAiHint="HUB Manager Contact Name" [aiHintForm]="icdForm" />
                             
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Number">Hub Number <code>*</code></label>
                            <div class="col-md-12">
                              <input   type="text" id="login-HUB_Manager_Contact_Number" name="HUB_Manager_Contact_Number" placeholder="Enter Manager Contact Number"
                                     autocomplete="current-Owner_Last_Name" class="form-control"  formControlName="HUB_Manager_Contact_Number"
                                     appAiHint="HUB Manager Contact Number" [aiHintForm]="icdForm" />
                              
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Email">Hub Email <code>*</code></label>
                            <div class="col-md-12">
                              <input  type="text" id="login-HUB_Manager_Contact_Email"
                                     name="HUB_Manager_Contact_Email" placeholder="Enter Manager Contact Email" autocomplete="current-HUB_Manager_Contact_Email"
                                     class="form-control"  formControlName="HUB_Manager_Contact_Email"
                                     appAiHint="HUB Manager Contact Email" [aiHintForm]="icdForm" />
                              
                            </div>
                          </div>
                        </div>

                      </div>

                      <!-- /.card-body -->
                    </div>
                  </div>

                  <div class="mb-3" *ngIf="btnDisplay">
                    <div class="callout callout-info">
                      <h6>***</h6>
                      Upon clicking Submit, an email will be sent to the ICD Owner with a link to continue the onboarding process.
                      <button type="submit" class="btn btn-success float-right">
                         SUBMIT

                      </button>


                    </div>
                   
                     
                  </div>
                </form>
               
              </div>

               

            </div>
            <!-- /.card-body -->
            <div class="card-footer"></div>
            <!-- /.card-footer-->
        </div>
    </div>
    <!-- /.card -->
</section>
